var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 108,
    viewBox: "0 0 105 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_4072)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.00391,
    y: 0.500977,
    width: 93.3333,
    height: 93.3333,
    rx: 26.6667,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.67057,
    y: 1.16764,
    width: 92,
    height: 92,
    rx: 26,
    stroke: "#F1F3F7",
    strokeWidth: 1.33333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.667 8.27637C40.9692 8.27637 33.3859 16.128 24.4181 18.9903C20.7704 20.1569 18.9465 20.7364 18.2076 21.5569C17.4687 22.3736 17.2548 23.5753 16.8231 25.9708C12.1954 51.6219 22.3065 75.3364 46.4176 84.5686C49.0037 85.5603 50.2987 86.0542 52.6787 86.0542C55.0587 86.0542 56.3576 85.5564 58.9476 84.5647C83.0548 75.3364 93.1542 51.6219 88.5265 25.9708C88.0948 23.5753 87.877 22.3736 87.1381 21.553C86.3992 20.7325 84.5793 20.153 80.9315 18.9903C71.9598 16.128 64.3648 8.27637 52.667 8.27637Z",
    stroke: "black",
    strokeWidth: 3.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8686 39.2279C45.8686 38.9945 45.8997 37.649 45.9075 35.9612C45.9075 34.4134 45.7753 32.9279 46.5141 31.5668C49.2753 26.0679 57.2086 26.6279 59.1686 32.2279C59.5069 33.1495 59.5303 34.6079 59.5186 35.9612C59.5069 37.684 59.5419 39.2279 59.5419 39.2279M46.2069 40.8651C42.0069 40.8651 39.9069 43.8984 39.4403 45.7651C38.9736 47.6318 38.9736 54.3984 39.2536 57.1984C40.1869 60.6984 42.5203 62.1451 44.8069 62.6118C46.9069 62.7984 55.7736 62.7284 58.3403 62.7284C62.0736 62.7984 64.8736 61.3984 66.0403 57.1984C66.2736 55.7984 66.5069 48.0984 65.9236 45.7651C64.6869 42.0318 61.6069 40.8651 59.2736 40.8651H46.2069Z",
    stroke: "black",
    strokeWidth: 3.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_4072",
    x: 0.670573,
    y: 0.500977,
    width: 103.999,
    height: 106.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_4072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_4072",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityLock);
export default __webpack_public_path__ + "static/media/Security-lock.c81f42315a05d40eefd0b37a93b019a2.svg";
export { ForwardRef as ReactComponent };